import styled from "styled-components";
import { motion } from "framer-motion";

export const H_Container = styled(motion.div)`
	height: 86px;

	display: grid;
	grid-template-columns: 170px max-content;
	gap: 10px;
	justify-content: start;
`;
export const headerVariants = {
	hidden: {},

	visible: {
		transition: {
			when: "beforeChildren",
			staggerChildren: 0,
		},
	},
	exit: {},
};
